var React = require('react');

function CircleEmptyInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"5.5","strokeWidth":"2"}));
}

CircleEmptyInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = CircleEmptyInline;

CircleEmptyInline.default = CircleEmptyInline;
